const asyncActionType = type => ({
  pending: `${type}_PENDING`,
  success: `${type}_SUCCESS`,
  error: `${type}_ERROR`
});

export const LOGIN = asyncActionType('cetfor/auth/LOGIN');
export const LOGOUT = asyncActionType('cetfor/auth/LOGOUT');
